// import consts from "@/consts.js";
import Request from './request';


async function tree(data) {
    return Request('get', "api/qacenter-categories/tree", data);
}

async function save(id,data){// 编辑或新建数据（有id为编辑，没有id为新建）
    if(id){
        return Request('patch', "api/qacenter-categories/edit?id=" + id, data);
    } else {
        return Request('patch', "api/qacenter-categories/add" , data);
    }
}

async function del(id){// 删除数据
    return Request('get', "api/qacenter-categories/del/", id ? { id: id} : {});
}

export default {
    tree,
    save,
    del
};